import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/addAssuranceZonePdp/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAddAssuranceZonePdpSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAddAssuranceZonePdpSelector };
